<template>
  <div class="content-container">
    <filter-location-statuses-data />
    <div class="content-wrap">
      <location-statuses />
    </div>
  </div>
</template>

<script>
import LocationStatuses from "@/components/LocationStatuses.vue";
import FilterLocationStatusesData from "@/components/FilterLocationStatusesData.vue";

export default {
  name: "LocationStatusesView",
  components: {
    LocationStatuses,
    FilterLocationStatusesData,
  },
};
</script>

<style scoped>
.content-container {
  background-color: var(--surface-secondary);
}
</style>
